module.exports = __webpack_public_path__ + "img/file-magnifying-glass.f04df0a0.svg";